import { createRoot } from 'react-dom/client'
import './style.css'
import App from './App'

// Log that bundle loaded
console.log('Stredge Glass Cube Bundle: Loading...')

// Expose the render function in a way that avoids global React conflicts
window.__stredgeRenderApp = function(container, props = {}) {
  console.log('__stredgeRenderApp called', container, props)
  if (!container) return false
  try {
    const root = createRoot(container)
    root.render(<App {...props} />)
    return true
  } catch (error) {
    console.error('Error rendering Stredge App:', error)
    return false
  }
}

// Confirm it's set
console.log('Stredge Glass Cube Bundle: __stredgeRenderApp exposed =', typeof window.__stredgeRenderApp)

// For standalone use (non-plugin context), mount to #root if it exists
const rootElement = document.getElementById('root')
if (rootElement) {
  console.log('Stredge: Rendering to #root element')
  window.__stredgeRenderApp(rootElement)
}
